module.exports = __webpack_public_path__ + "img/pr-6.757b1465.png";